import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useEffect, useRef} from "react";
import {SuMMARY_DEFAULT} from "../../actions/path";
import runningShipImg from '../../assets/running_ship.png'
import Summary from "./index";
import {BTN_KEY} from "../../util/util";

const Projects2 = ({changeBtnKey, allMode = false}) => {
    const projectList = [
        {
            companyInfo: '소속 회사',
            title: '사내 그룹웨어(NOSUM)',
            period: '2024.01 ~ 2024.03',
            content: '사내 솔루션 부서 전용 그룹웨어 (업무 기록, PO사 정보, 계약 관리)',
            skill: 'Java Spring JPA React JS MySQL Git',
            thumbnailPath : '',
        },
        {
            companyInfo: 'PO사: 하나카드 | 고객사: 하나금융티아이',
            title: 'WCMS 고도화',
            period: '2024.04 ~ 2024.06',
            content: '클라이언트 페이지 구성에 필요한' +
                '데이터를 적재하기 위한 입력 폼 및 API 개발',
            skill: 'Java Spring MyBatis React JS Oracle SVN',
            thumbnailPath : '',
        },
        {
            companyInfo: 'PO사: 하나카드 | 고객사: 하나금융티아이',
            title: 'WCMS 마이그레이션',
            period: '2024.06 ~ 2024.10',
            content: '구 WCMS 로 개발된 입력 폼 및 API → 신규 WCMS 환경에 맞춰 전환 개발',
            skill: 'Java Spring MyBatis React JS Oracle SVN',
            thumbnailPath : '',
        },
        {
            companyInfo: 'PO사: LG 전자 | 고객사: LG CNS',
            title: 'LG.com D2X 플랫폼 구축 - Multishop (지원)',
            period: '2024.11 ~ 2024.12',
            content: '학교, SMB(중소기업) 등 특정 대상 타켓 커머스 플랫폼' +
                '- 단위테스트, SIT, UAT 결함 대응 개발',
            skill: 'Java React JS AEM Git',
            thumbnailPath : '',
        },
        {
            companyInfo: 'PO사: LG 전자 | 고객사: LG CNS',
            title: 'LG.com Monthly LG 개발 ',
            period: '2025.01 ~ 2025.02',
            content: 'Monthly LG 페이지에 필요한 컴포넌트(Magazine) 개발',
            skill: 'Java React JS AEM Git',
            thumbnailPath : '',
        },
        {
            companyInfo: 'PO사: LG 전자 | 고객사: LG CNS:',
            title: 'LG.com Monthly LG 통합 유지보수',
            period: '2025.03',
            content: 'Monthly LG 페이지 전체 컴포넌트 오픈 후 결함 대응 및 수정 요청 건 개발',
            skill: 'Java React JS AEM Git',
            thumbnailPath : '',
        },
        {
            companyInfo: 'PO사: LG 전자 | 고객사: LG CNS',
            title: 'LG.com Monthly LG 고도화',
            period: '2025.04',
            content: 'Monthly LG 페이지 전체 컴포넌트 추가 개발',
            skill: 'Java React JS AEM Git',
            thumbnailPath : '',
        },
        {
            companyInfo: 'PO사: LG 전자 | 고객사: LG CNS',
            title: 'LG.com 25년 OBS무형상품 판매 서비스 Pilot 구축',
            period: '2025.04 ~ 2025.07',
            content: 'LG.com 무형상품 (제품 관련 보험, 세척) 판매 서비스 중 무형상품 PBP 페이지 개발 (인도)',
            skill: 'Java React JS AEM Git',
            thumbnailPath : '',
        },
        {
            companyInfo: 'PO사: LG 전자 | 고객사: LG CNS',
            title: 'LG.com 25년 OBS무형상품 판매 서비스 RollOut 확산',
            period: '2025.07 ~ 2025.11',
            content: 'LG.com 무형상품 (제품 관련 보험, 세척) 판매 서비스 중 무형상품 PBP 페이지 개발 (멕시코, 베트남, 이탈리아)',
            skill: 'Java React JS AEM Git',
            thumbnailPath : '',
        },
        {
            companyInfo: 'PO사: LG 전자 | 고객사: LG CNS',
            title: 'LG.com Multishop Sign-in 개선 프로젝트 (지원)',
            period: '2025.11 ~ 2025.12',
            content: 'Multishop 플랫폼 로그인 시 통합회원 이메일 인증 여부 확인 API 개발',
            skill: 'Java Spring MyBatis MariaDB Git',
            thumbnailPath : '',
        },
        {
            companyInfo: 'PO사: LG 전자 | 고객사: LG CNS',
            title: 'LG.com Support API 표준화',
            period: '2025.12 ~ 2026.3',
            content: 'Support API 표준화',
            skill: 'Java Spring MyBatis MariaDB JS React AEM Git',
            thumbnailPath : '',
        },
    ]

    const activeTarget = 'choice-summary-2';
    const focusRef = useRef();
    useEffect(() => {
        if (allMode) return;
        document.querySelector(`#${activeTarget}`)?.classList?.add('border-primary');
        focusRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    },[]);

    return (
        <>
            <main className='container' ref={focusRef}>
                <hr className='featurette-divider'/>
                {!allMode && (
                    <div className='right-align'>
                        <h4>
                            <div>
                                <div className="fold-btn mt-2 mb-4">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                                         fill="currentColor"
                                         className="bi bi-x-circle custom-fold-top" viewBox="0 0 16 16"
                                         onClick={() => {
                                             changeBtnKey(BTN_KEY.DEFAUlT);
                                         }}>
                                        <path
                                            d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                        <path
                                            d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"></path>
                                    </svg>
                                </div>
                            </div>
                        </h4>
                    </div>
                )}
                {/*<div className="p-2 rounded text-body-emphasis ">*/}
                {/*    <div className="col-lg-6 px-0">*/}
                {/*        🏢 소속 회사: (주)***소프트 2024.01 ~ 현재*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*<div className="p-4 p-md-5 my-3 bg-primary bg-gradient rounded-3 shadow-lg text-center text-white">*/}
                <div className="p-4 p-md-5 my-3 bg-primary bg-gradient rounded-3 shadow-lg text-center text-white">
                    <h1 className="fs-3 fs-md-1 fw-bold mb-3">
                        ⛵ 나만의 항해일지 🐳
                    </h1>
                    <p className="fs-6 fs-md-5 opacity-75">
                        오늘도 새로운 여정을 기록합니다
                    </p>
                    <hr className="w-50 w-md-25 mx-auto border-light opacity-75"/>
                </div>
                {/*<div className="bg-ocean row mb-2">*/}
                <div className="bg-ocean row mb-2">
                    {/* 카드 */}
                    {projectList?.slice().reverse().map((item, index) =>
                        <div className={`col-md-6 fade-item ${'delay-' + (index + 1)}`}
                             key={`project-${index + 1}`}>
                            <div
                                className="bg-in-ocean-box bg-color-thistle row g-0 border rounded overflow-hidden flex-md-row mb-4 shadow-sm h-md-250 position-relative">
                                <div className="col p-4 d-flex flex-column position-static">
                                    <strong className="d-inline-block mb-2 text-primary-emphasis">
                                        {item?.companyInfo}
                                    </strong>
                                    <h3 className="mb-0">{item?.title}</h3>
                                    <div className="mb-1 text-body-secondary">{item?.period}</div>
                                    <p className="card-text mb-auto">
                                        {item?.content}
                                    </p>
                                    <div
                                        // href="#"
                                        className="font-highlight no-line-href icon-link gap-1 icon-link-hover stretched-link"
                                    >
                                        {item?.skill}
                                        <svg className="bi" aria-hidden="true">
                                            <use xlinkHref="#chevron-right"></use>
                                        </svg>
                                    </div>
                                </div>
                                <div className="col-auto d-none d-lg-block projects-thumbnail">
                                    <img
                                        aria-label="Placeholder: Thumbnail"
                                        className="bd-placeholder-img custom-ship-img"
                                        height="250"
                                        preserveAspectRatio="xMidYMid slice"
                                        role="img"
                                        width="200"
                                        // xmlns="http://www.w3.org/2000/svg"
                                        src={runningShipImg}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </main>
        </>
    );
}

export default Projects2;